import type { Snapshot } from '@ember-data/legacy-compat/-private';
import ApplicationSerializer from 'lumen/serializers/application';

export default class CurrencyConversionExchangeRateSerializer extends ApplicationSerializer {
  attrs = {
    currencyCode: { serialize: true },
    value: { serialize: true },
    endDate: { serialize: false },
    startDate: { serialize: false },
    exchangeRatesProfile: { serialize: false },
  };

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  serialize(snapshot: Snapshot, options?: object) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-assignment
    const json = super.serialize(snapshot, options);

    // Ensure id is always serialized as an integer when present
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (json && typeof json === 'object' && 'id' in json && json['id']) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      json['id'] = parseInt(json['id'] as string, 10);
    }

    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return json;
  }
}
